export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20warm%20glowing%20abstract%20background%20with%20soft%20gradient%20from%20dark%20amber%20to%20deep%20charcoal%2C%20subtle%20particle%20effects%2C%20minimal%20elegant%20composition%2C%20cinematic%20lighting%2C%20dramatic%20yet%20clean%20aesthetic&width=1800&height=600&seq=cta-bg-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-foreground-950/80"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-50 mb-6">
          准备好迎接今日挑战了吗？
        </h2>
        <p className="text-lg text-foreground-200/80 max-w-xl mx-auto mb-10 leading-relaxed">
          加入50万+玩家的行列，每天参与竞技，赢取丰厚奖励。现在就开启您的每日挑战之旅！
        </p>
        <button className="px-10 py-4 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
          免费注册，立即参赛
          <i className="ri-rocket-line ml-2"></i>
        </button>
      </div>
    </section>
  );
}